import { lazy } from "react";

import Login from "@features/Autenticacion/page/Login";
import WhiteZone from "@components/WhiteZone";

export const loginRoutes = {
    Component: Login,
    errorElement: <WhiteZone error />,
    path: "/",
};
